import Actions from 'reducers/Archived'
import Release from 'models/Release'
import { ArchiveService, ReleasesService } from 'services'
import cloneDeep from 'lodash/cloneDeep'
import { releasePageSize } from 'config'
import { storeHelpers } from 'utils'
import type { AppDispatch } from 'types/store'

export const search = (page: number) => (dispatch: AppDispatch) => {
  dispatch(Actions.loadingArchivedStart())
  storeHelpers
    .asyncGetStoreState()
    .then((state: any) => {
      const { archived: archivedState } = state
      const params = {
        page,
        pagesize: releasePageSize,
        sort: archivedState.sort,
      }
      ReleasesService.getArchived(params)
        .then((response: any) => {
          let items = response.data.items
          items = items.map((item: any) => {
            const result = cloneDeep(item)
            result.publisher = Release.getPublisher(item)
            return result
          })
          const totalItemsCount = response.data.total
          dispatch(Actions.loadingArchivedSuccess(items, page, totalItemsCount))
        })
        .catch((error: any) => {
          console.warn(error)
          dispatch(Actions.loadingArchivedError(error))
        })
    })
    .catch((e: any) => {
      console.warn(e)
      dispatch(Actions.loadingArchivedError(e))
    })
}

export const refreshList = () => (dispatch: AppDispatch) => {
  dispatch(Actions.refreshArchived())
  dispatch(search(1) as any)
}

export const sortBy = (attribute: string) => (dispatch: AppDispatch) => {
  dispatch(Actions.sortArchivedBy(attribute))
  dispatch(refreshList() as any)
}

export const clearAll =
  (successCallback?: () => void) => (dispatch: AppDispatch) => {
    dispatch(Actions.restoreAllStart())
    ArchiveService.clear()
      .then(() => {
        dispatch(Actions.restoreAllSuccess())
        if (successCallback) successCallback()
      })
      .catch((error: any) => {
        console.warn(error)
        dispatch(Actions.restoreAllError())
      })
  }

export const restoreRelease =
  (releaseId: string, successCallback?: () => void) => () => {
    ArchiveService.restoreRelease(releaseId)
      .then(() => {
        if (successCallback) successCallback()
      })
      .catch((error: any) => {
        console.warn(error)
      })
  }

export default {
  search,
  refreshList,
  sortBy,
  clearAll,
  restoreRelease,
}
